import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getGridV2EffectiveVersion,
  getIsGridV2,
  getIsGridV2OptedOut,
  getIsGridV2Resolved,
  getIsPricedOnGridV2,
} from "./selectors";

/**
 * What every Grid V2 element reads instead of the LD experiment: an opted-out
 * user still carries the `available` variant but must see V1.
 * - `isGridV2`: in the V2 variant, sticky through an opt-out.
 * - `isPricedOnGridV2`: what the V2 elements gate on, false after an opt-out.
 */
export const useGridV2 = () => {
  const effectiveVersion = useSelector(getGridV2EffectiveVersion);
  const isGridV2 = useSelector(getIsGridV2);
  const isPricedOnGridV2 = useSelector(getIsPricedOnGridV2);
  const isResolved = useSelector(getIsGridV2Resolved);
  const isOptedOut = useSelector(getIsGridV2OptedOut);

  return useMemo(
    () => ({
      effectiveVersion,
      isGridV2,
      isPricedOnGridV2,
      isResolved,
      isOptedOut,
    }),
    [effectiveVersion, isGridV2, isPricedOnGridV2, isResolved, isOptedOut]
  );
};
